import CommonService from "@/services/v2/intranet/common.service";

export const commonApi = {
  namespaced: true,
  state: {
    quarterFunding: null,
    isLoading: false,
    error: null,
  },
  getters: {
    getQuarterFunding: (state) => state.quarterFunding,
    isLoading: (state) => state.isLoading,
    hasError: (state) => state.error !== null,
    getError: (state) => state.error,
  },
  actions: {
    fetchQuarterFunding({ commit }, priorMonth) {
      commit("setIsLoading", true);
      commit("clearError");

      return CommonService.getThisQuarterFunding(priorMonth).then(
        (resp) => {
          commit("setQuarterFunding", resp.data);
          commit("setIsLoading", false);
          commit(
            "dummyConsole",
            "Intranet/CommonService.getThisQuarterFunding - success"
          );
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            "setError",
            error.message || "Failed to fetch this quarter funding"
          );
          commit("setIsLoading", false);
          commit(
            "dummyConsole",
            "Intranet/CommonService.getThisQuarterFunding - error"
          );
          return Promise.reject(error);
        }
      );
    },
    postConvertBundlingBookmarks(_, formData) {
      return CommonService.postConvertBundlingBookmarks(formData); // ⭐ return 필수
    }
  
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setQuarterFunding(state, data) {
      state.quarterFunding = data;
    },
    setIsLoading(state, loading) {
      state.isLoading = loading;
    },
    setError(state, error) {
      state.error = error;
    },
    dummyConsole(_state, obj) {
      console.log(obj);
    },
  },
};

export default commonApi;
